import { Card as MuCard } from '@material-ui/core';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import styles from '../../../pages/editors/RoadCondition.module.scss';

const Card = props => {
    const theme = useTheme();
    const useStyles = makeStyles({
        root: {
            display: "inline-block",
            border: "1px solid lightgray",
            width: "200px",
            height: "200px",
            marginRight: "20px",
            marginBottom: "15px",
            [theme.breakpoints.down('xs')]: {
                margin: "0 auto 20px",
                display: "block"
            },
        },
        pageMargin: {
            margin: "0 6%",
            minHeight: '480px'
        },
        marginTop: {
            marginTop: '3%'
        },
        img: {
            maxHeight: '100%',
            maxWidth: '100%',
            objectFit: 'contain',
            height: "100px",
            width: "100px",
            margin: "auto"
        },
        widerLogo:{
            width: "160px",
            height:"auto",
            marginBottom: "11px",
            marginTop: "30px"
        },
        button: {
            height: "200px"
        },
        h2: {
            margin: "0!important",
            textAlign: "center",
            fontSize: "18px!important"
        },

    });

    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [preValue, setPreValue] = React.useState(0);
    const handleTabChange = (event, newValue) => {
        // setPreValue(value);
        setValue(newValue);
    };
    // const handleClick = (redirectToPath) => {
    //     if(redirectToPath) {
    //         props.history.push(redirectToPath);
    //       }
    // };
    const successToast = (toastMessage) => {
        toast.success(toastMessage, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            autoClose: 3000,
            className: styles.toastSuccess
        });
    };
    const errorToast = (toastMessage) => {
        toast.error(toastMessage, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            autoClose: 3000
        });
    };
    return (

        <MuCard className={classes.root} >
            <CardActionArea className={classes.button} onClick={props.handleClick}>
                <CardMedia
                    component="img"
                    alt={props.title}
                    height={250}
                    image={props.imgSrc}
                    title={props.title}
                    classes={{ img: classes.img +" "+ (props.widerLogo && props.widerLogo==true?classes.widerLogo:"") }}
                    onClick={props.handleClick}
                />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2" className={classes.h2}>
                        {props.cardContent}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </MuCard>

    );
}

export default withRouter(props => <Card {...props} />);